import React, { useMemo } from 'react';
import { PredictionHeaderBar } from '../../../components/prediction-header-bar/prediction-header-bar';
import { useStandardOrganisationPredictionBuilderContext } from '../../../context/standard-organisation-prediction-builder-context';
import { PredictionHeaderProps, PredictionType } from '../../../types';

export const PredictionHeader = ({ children, ...props }: PredictionHeaderProps) => {
  const { handlePredictionTypeChange, isEditing, predictionType } = useStandardOrganisationPredictionBuilderContext();

  const options = useMemo(
    () => [PredictionType.FORMULA, PredictionType.FREESTYLE, PredictionType.REPEATING, PredictionType.UNIT],
    []
  );

  return (
    <PredictionHeaderBar
      isEditing={isEditing}
      onChangePredictionType={handlePredictionTypeChange}
      options={options}
      predictionType={predictionType}
      {...props}
    >
      {children}
    </PredictionHeaderBar>
  );
};
